const ADD_CREDIT_CARD = 'NEW_PAYMENT_ADD_CREDIT_CARD';
const CLEAR_AUTH_MESSAGE = 'NEW_CLEAR_AUTH_MESSAGE';
const DELETE_USER_PAYMENT = 'NEW_PAYMENT_DELETE_USER_PAYMENT';
const GET_GIFT_CARD_LIST = 'NEW_GET_GIFT_CARD_LIST';
const GET_SPECIAL_DISCOUNT_INFO = 'NEW_GET_SPECIAL_DISCOUNT_INFO';
const GIFT_CARD_FORM_CHANGE_VALUE = 'NEW_GIFT_CARD_FORM_CHANGE_VALUE';
const GIFT_CARD_FORM_ERROR = 'NEW_GIFT_CARD_FORM_ERROR';
const GIFT_CARD_FORM_FIELD_ERROR = 'NEW_GIFT_CARD_FORM_FIELD_ERROR';
const GIFT_CARD_FORM_SUBMIT = 'NEW_GIFT_CARD_FORM_SUBMIT';
const APP_WALLET_GIFT_CARD_FORM_SUBMIT = 'APP_WALLET_GIFT_CARD_FORM_SUBMIT';
const HIDE_NEW_CREDIT_CARD_FORM = 'HIDE_NEW_CREDIT_CARD_FORM';
const HIDE_REGISTER_UPDATE_CREDIT_CARD_FORM = 'HIDE_REGISTER_UPDATE_CREDIT_CARD_FORM';
const INIT_EMPTY_CREDIT_CARD_FORM = 'NEW_PAYMENT_INIT_EMPTY_CREDIT_CARD_FORM';
const INIT_GUEST_UPDATE_CREDIT_CARD_FORM = 'NEW_PAYMENT_INIT_GUEST_UPDATE_CREDIT_CARD_FORM';
const INIT_NEW_PAYMENT = 'NEW_PAYMENT_INIT_NEW_PAYMENT';
const INIT_REGISTER_UPDATE_CREDIT_CARD_FORM = 'NEW_PAYMENT_INIT_REGISTER_UPDATE_CREDIT_CARD_FORM';
const REMOVE_GIFTCARD_REQUEST = 'NEW_REMOVE_GIFTCARD_REQUEST';
const SELECT_USER_PAYMENT = 'NEW_PAYMENT_SELECT_USER_PAYMENT';
const SET_ADDRESS_STAND_NOT_REQUIRED = 'NEW_PAYMENT_SET_ADDRESS_STAND_NOT_REQUIRED';
const SET_DEFAULT_PREFERENCE_CREDIT_CARD_TO_PROFILE =
    'NEW_PAYMENT_SET_DEFAULT_PREFERENCE_CREDIT_CARD_TO_PROFILE';
const SET_DELETE_CONFIRMATIONMODAL_INFO = 'NEW_PAYMENT_SET_DELETE_CONFIRMATIONMODAL_INFO';
const SET_SAVE_CREDIT_CARD_TO_PROFILE = 'NEW_PAYMENT_SET_SAVE_CREDIT_CARD_TO_PROFILE';
const SHOW_BILLING_ADDRESS_FORM = 'NEW_PAYMENT_SHOW_BILLING_ADDRESS_FORM';
const SHOW_HIDE_GIFTCARD_FORM = 'NEW_SHOW_HIDE_GIFTCARD_FORM';
const TOGGLE_NEW_CREDIT_CARD_FORM = 'NEW_PAYMENT_TOGGLE_NEW_CREDIT_CARD_FORM';
const UPDATE_CREDIT_CARD_FORM = 'NEW_PAYMENT_UPDATE_CREDIT_CARD_FORM';
const UPDATE_CREDIT_CARD_FORM_ERROR = 'NEW_PAYMENT_UPDATE_CREDIT_CARD_FORM_ERROR';
const UPDATE_CREDIT_CARD_FORM_FIELD_ERROR = 'NEW_PAYMENT_UPDATE_CREDIT_CARD_FORM_FIELD_ERROR';
const UPDATE_PAYMENT_METHOD_TYPE = 'NEW_UPDATE_PAYMENT_METHOD_TYPE';
const UPDATE_PAYMENT_METHOD_TYPE_SUCCESS = 'NEW_UPDATE_PAYMENT_METHOD_TYPE_SUCCESS';
const UPDATE_PROFILE_PAYMENT_LIST = 'NEW_PAYMENT_UPDATE_PROFILE_PAYMENT_LIST';
const UPDATE_USER_PAYMENT = 'NEW_PAYMENT_UPDATE_USER_PAYMENT';
const UPDATE_PAYPAL_CONTACT_INFO = 'UPDATE_PAYPAL_CONTACT_INFO';
const GET_APP_GIFT_CARDS = 'GET_APP_GIFT_CARDS';
const GIFT_CARDS_FROM_APP = 'GIFT_CARDS_FROM_APP';
const POLL_GC_BALANCE_INFO = 'POLL_GC_BALANCE_INFO';
const STOP_POLLING_GET_GC_BALANCE_INFO = 'STOP_POLLING_GET_GC_BALANCE_INFO';
const CONTINUE_PROCESSING_WEB_APP_GC_BALANCE = 'WEB_GET_APP_GC_BALANCE_REQUEST';
const GIFT_CARDS_BALANCE_FROM_APP = 'GIFT_CARDS_BALANCE_FROM_APP';
const ADD_BNPL_TO_ORDER = 'ADD_BNPL_TO_ORDER';
const UPDATE_DELETED_CC = 'UPDATE_DELETED_CC';
const SET_HAS_MARKETPLACE_ITEMS_IN_CART = 'SET_HAS_MARKETPLACE_ITEMS_IN_CART';
export {
    ADD_CREDIT_CARD,
    CLEAR_AUTH_MESSAGE,
    DELETE_USER_PAYMENT,
    GET_GIFT_CARD_LIST,
    GET_SPECIAL_DISCOUNT_INFO,
    GIFT_CARD_FORM_CHANGE_VALUE,
    GIFT_CARD_FORM_ERROR,
    GIFT_CARD_FORM_FIELD_ERROR,
    GIFT_CARD_FORM_SUBMIT,
    APP_WALLET_GIFT_CARD_FORM_SUBMIT,
    HIDE_NEW_CREDIT_CARD_FORM,
    HIDE_REGISTER_UPDATE_CREDIT_CARD_FORM,
    INIT_EMPTY_CREDIT_CARD_FORM,
    INIT_GUEST_UPDATE_CREDIT_CARD_FORM,
    INIT_NEW_PAYMENT,
    INIT_REGISTER_UPDATE_CREDIT_CARD_FORM,
    REMOVE_GIFTCARD_REQUEST,
    SELECT_USER_PAYMENT,
    SET_ADDRESS_STAND_NOT_REQUIRED,
    SET_DEFAULT_PREFERENCE_CREDIT_CARD_TO_PROFILE,
    SET_DELETE_CONFIRMATIONMODAL_INFO,
    SET_SAVE_CREDIT_CARD_TO_PROFILE,
    SHOW_BILLING_ADDRESS_FORM,
    SHOW_HIDE_GIFTCARD_FORM,
    TOGGLE_NEW_CREDIT_CARD_FORM,
    UPDATE_CREDIT_CARD_FORM_ERROR,
    UPDATE_CREDIT_CARD_FORM_FIELD_ERROR,
    UPDATE_CREDIT_CARD_FORM,
    UPDATE_PAYMENT_METHOD_TYPE,
    UPDATE_PAYMENT_METHOD_TYPE_SUCCESS,
    UPDATE_PROFILE_PAYMENT_LIST,
    UPDATE_USER_PAYMENT,
    UPDATE_PAYPAL_CONTACT_INFO,
    GET_APP_GIFT_CARDS,
    GIFT_CARDS_FROM_APP,
    POLL_GC_BALANCE_INFO,
    STOP_POLLING_GET_GC_BALANCE_INFO,
    CONTINUE_PROCESSING_WEB_APP_GC_BALANCE,
    GIFT_CARDS_BALANCE_FROM_APP,
    ADD_BNPL_TO_ORDER,
    UPDATE_DELETED_CC,
    SET_HAS_MARKETPLACE_ITEMS_IN_CART,
};
